// extracted by mini-css-extract-plugin
export default {"container":"Propmts_container__nV035","box":"Propmts_box__qn06P"};